const UniqueId = {
  nextId: 0,

  decimalToHex: function (d: number, padding?: number) {
    var hex = Number(d).toString(16);
    padding = typeof padding === 'undefined' || padding === null ? (padding = 2) : padding;

    while (hex.length < padding) {
      hex = '0' + hex;
    }

    return hex;
  },

  getShortId: function () {
    var id = this.nextId++;
    return this.decimalToHex(id);
  },
};

export default UniqueId;
